export enum LogLevel {
    DEBUG,
    INFO,
    WARN,
    ERROR
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/domain/enums/log-level.enum.ts